import { logAndThrowHttpError } from '@sky-distribution/gp-onboarding-monitoring';
import { api } from '../api';
import { ApiPath } from '../config';
import { ProductCalculateWorthResponse, ProductConfigResponse, ProductMetaDataResponse } from './ProductConfiguration.types';

const defaultProductId = 'exw';

class ProductConfigurationService {
  async getProductConfig(
    property: string,
    requestData: unknown,
    productId: string = defaultProductId,
  ): Promise<ProductConfigResponse> {
    const { data } = await api({ productId })
      .get<ProductConfigResponse>(`${ApiPath.PRODUCT_CONFIGURATION}/${property}`, { params: requestData })
      .catch(
        logAndThrowHttpError<ProductConfigResponse>(
          'getProductConfiguration',
          requestData,
        ),
      );

    return data;
  }

  async getProductMetaData(
    partner: string,
    businessProductCode?: string,
    productId: string = defaultProductId,
  ): Promise<ProductMetaDataResponse> {
    const { data } = await api({ productId })
      .post<ProductMetaDataResponse>(ApiPath.PRODUCT_META_DATA, { partner, businessProductCode })
      .catch(
        logAndThrowHttpError<ProductMetaDataResponse>(
          'getProductMetaData',
          { partner, businessProductCode },
        ),
      );

    return data;
  }

  async getProductCalculatedWorth(
    reqBody: Record<string, unknown>,
    productId: string = defaultProductId,
  ): Promise<ProductCalculateWorthResponse> {
    const { data } = await api({ productId })
      .post<ProductCalculateWorthResponse>(ApiPath.PRODUCT_WORTH, (reqBody))
      .catch(logAndThrowHttpError<ProductCalculateWorthResponse>('getProductCalculatedWorth', reqBody));

    return data;
  }
}

export const productConfigurationService = new ProductConfigurationService();
